import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import quoteService from "../services/quoteService";

export const useQuotes = () => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchCode, setSearchCode] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);

  const fetchQuotes = async (page = 1, codigo = searchCode) => {
    setLoading(true);
    try {
      const data = await quoteService.fetchQuotes(page, fromDate, toDate, codigo);

      if (data.data) {
        setQuotes(data.data);
        setCurrentPage(data.current_page);
        setTotalPages(data.last_page);
        setTotal(data.total);
        setFrom(data.from);
        setTo(data.to);
      } else {
        setQuotes(Array.isArray(data) ? data : []);
      }
    } catch (error) {
      console.error("Error al cargar cotizaciones:", error);
      Swal.fire("Error", "No se pudieron cargar las cotizaciones", "error");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      fetchQuotes(newPage);
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchQuotes(1, searchCode);
  };

  const handleClearFilters = () => {
    setFromDate("");
    setToDate("");
    setSearchCode("");
    setCurrentPage(1);
    fetchQuotes(1, "");
  };

  const handleDownloadPdf = async (quote) => {
    try {
      const blob = await quoteService.downloadPdf(quote.id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Cotizacion_${quote.correlativo}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error al descargar PDF:", error);
      Swal.fire("Error", "No se pudo descargar el PDF", "error");
    }
  };

  const handleDelete = async (quote) => {
    const result = await Swal.fire({
      title: "¿Eliminar cotización?",
      text: `Se eliminará la cotización N° ${quote.correlativo}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        await quoteService.deleteQuote(quote.id);
        Swal.fire("Eliminada", "La cotización fue eliminada", "success");
        fetchQuotes(currentPage);
      } catch (error) {
        console.error("Error al eliminar cotización:", error);
        Swal.fire("Error", "No se pudo eliminar la cotización", "error");
      }
    }
  };

  useEffect(() => {
    fetchQuotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    quotes,
    loading,
    fromDate,
    toDate,
    searchCode,
    currentPage,
    totalPages,
    total,
    from,
    to,
    setFromDate,
    setToDate,
    setSearchCode,
    fetchQuotes,
    handlePageChange,
    handleSearch,
    handleClearFilters,
    handleDownloadPdf,
    handleDelete,
  };
};